<!-- Login.vue -->
<template>
    <div class="glass-panel login-card">
        <div class="login-header">
            <div class="avatar-wrapper">
                <img src="/img/mingchen.jpg" alt="Avatar" class="avatar-img">
            </div>
            <h2 class="welcome-text">欢迎回来</h2>
            <p class="subtitle">登录您的账号以继续</p>
        </div>

        <a-form
            ref="loginFormRef"
            :model="loginForm"
            :rules="loginFormRules"
            class="login-form"
            layout="vertical"
        >
            <a-form-item field="email" hide-label>
                <a-input
                    v-model="loginForm.email"
                    placeholder="邮箱地址"
                    size="large"
                    allow-clear
                >
                    <template #prefix>
                        <icon-email />
                    </template>
                </a-input>
            </a-form-item>
            <a-form-item field="password" hide-label>
                <a-input-password
                    v-model="loginForm.password"
                    placeholder="密码"
                    size="large"
                    allow-clear
                    @keyup.enter="handleLogin"
                >
                    <template #prefix>
                        <icon-lock />
                    </template>
                </a-input-password>
            </a-form-item>

            <div class="form-actions">
                <a-link @click="handleToRegister" class="action-link">注册新账号</a-link>
                <a-link class="action-link">忘记密码?</a-link>
            </div>

            <a-form-item hide-label>
                <a-button type="primary" size="large" long @click="handleLogin" :loading="loading">
                    立即登录
                </a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { Message } from '@arco-design/web-vue';
import { IconEmail, IconLock } from '@arco-design/web-vue/es/icon';
import { login } from "@/api/login";

export default defineComponent({
    name: "Login",
    components: {
        IconEmail,
        IconLock
    },
    emits: ['to-register'],
    setup(props, { emit }) {
        const router = useRouter();
        const loginFormRef = ref(null);
        const loading = ref(false);

        const loginForm = reactive({
            email: 'admin@gmail.com',
            password: 'admin'
        });

        const loginFormRules = {
            email: [
                { required: true, message: '请输入邮箱' },
                { type: 'email', message: '请输入有效的邮箱格式' }
            ],
            password: [
                { required: true, message: '请输入密码' }
            ]
        };

        const handleToRegister = () => {
            emit('to-register');
        };

        const handleLogin = async () => {
            const errors = await loginFormRef.value?.validate();
            if (!errors) {
                loading.value = true;
                try {
                    const res = await login(loginForm);
                    if (res.code === 200) {
                        Message.success({ content: '登录成功', duration: 2000 });
                        window.localStorage.setItem('adminToken', res.data.token);
                        router.push('/home');
                    } else {
                        Message.error(res.msg || '登录失败');
                    }
                } catch (error) {
                    Message.error("网络请求失败");
                } finally {
                    loading.value = false;
                }
            }
        };

        return {
            loginFormRef,
            loginForm,
            loginFormRules,
            loading,
            handleToRegister,
            handleLogin
        };
    }
});
</script>

<style scoped>
.login-card {
    padding: 40px;
    width: 100%;
    animation: slideUp 0.5s ease-out;
}

.login-header {
    text-align: center;
    margin-bottom: 30px;
}

.avatar-wrapper {
    width: 80px;
    height: 80px;
    margin: 0 auto 15px;
    border-radius: 50%;
    padding: 4px;
    background: rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.avatar-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

.welcome-text {
    font-size: 24px;
    color: var(--text-main);
    margin-bottom: 8px;
}

.subtitle {
    color: var(--text-secondary);
    font-size: 14px;
}

.form-actions {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.action-link {
    color: var(--text-secondary) !important;
    font-size: 13px;
}

.action-link:hover {
    color: var(--primary-color) !important;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
